import { render, staticRenderFns } from "./BarraNavegacao.vue?vue&type=template&id=18b4e20d&scoped=true&"
import script from "./BarraNavegacao.vue?vue&type=script&lang=js&"
export * from "./BarraNavegacao.vue?vue&type=script&lang=js&"
import style0 from "./BarraNavegacao.vue?vue&type=style&index=0&id=18b4e20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4e20d",
  null
  
)

export default component.exports